module.exports = {
  CLIENT_ID: 'l7xxece0943cdb214fe4b3b0cbcfbda4b0a1',
  AUTH_ROOT: 'https://auth-st.autozone.com',
  AUTH_SCOPE:
    'openid%20profile%20azjobinfo%20az_mobile_sso%20tech.store-locator.roles%3Aread%20comm.cdrd_egress:write%20comm.unified-picking:read%20comm.unified-picking:write%20comm.whispers:write%20comm.store_print:read%20tech.gemini',
  REDIRECT_URI: 'http://dev.autozone.com:3000',
  ENV: 'dv-ext',
  SSO_DEVICES: ['CT40'],
  INACTIVITY_TIMEOUT: 10,
  FETCH_TIMEOUT: 10000,
  INACTIVITY_TIMEOUT_FOR_TOASTS: 120000,
  APIGEE_BASE_URL: 'https://external-dv-api.autozone.com',
  WHATFIX_ENABLED: true,
  WHATFIX_TIMEOUT: 10000,
  WHATFIX_SCRIPT_URL: "https://cdn.whatfix.com/prod/abb6f400-cff2-11e9-ba18-c63d85ed437c/initiator/initiator.nocache.js",
  AUTOREFRESH_DELAY_TIME: 60000
};
